import type { CSSObject, MantineTheme } from '@mantine/core';

import { SUB_HEADER_SUBNAV_HEIGHT } from '../../constants';

export type SubNavLinkStyles = CSSObject & {
  '&.active': CSSObject;
  '&.disabled': CSSObject;
  '&:not(.disabled):hover': CSSObject;
};

export type CommonStyles = {
  widgetColumnLink: CSSObject;
  svgBgr: CSSObject;
  subNavContainer: CSSObject;
  subNavLink: SubNavLinkStyles;
  badge: CSSObject;
};

export const getCommonStyles = (theme: MantineTheme): CommonStyles => ({
  widgetColumnLink: {
    cursor: 'pointer',
    transition: 'color 0.2s ease-in-out',

    '&:hover': {
      color: theme.colors.blue[4],
    },
  },

  svgBgr: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    zIndex: 0,
  },

  subNavContainer: {
    display: 'flex',
    alignItems: 'stretch',
    height: SUB_HEADER_SUBNAV_HEIGHT,
    gap: theme.other.spacing._32,
    overflow: 'auto',
    width: '100%',

    [theme.fn.smallerThan('sm')]: {
      justifyContent: 'space-around',
      width: '100vw',
      margin: `0 -${theme.other.spacing._16}px`,
    },
  },

  subNavLink: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.white,
    textDecoration: 'none',
    padding: 0,
    borderTop: '2px solid transparent',
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in-out',
    whiteSpace: 'nowrap' as const,

    [theme.fn.smallerThan('sm')]: {
      flex: '1 0 65px',
    },

    '&:not(.disabled):hover': {
      color: theme.colors.blue[4],
      borderBottomColor: 'rgba(75, 235, 226, 0.5)',
    },

    '&.active': {
      color: theme.colors.blue[4],
      borderBottomColor: theme.colors.blue[4],
    },

    '&.disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  } satisfies SubNavLinkStyles,

  badge: {
    width: 6,
    height: 6,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 6,
    backgroundColor: theme.colors.red[4],
    marginLeft: theme.other.spacing._4,
  },
});
